import getApiCall from "./getApiCall";

export const  AppendBlobWithToken =async(blobUrl)=>{
const response = await getApiCall(`common/upload/blob/sas-token?url=${encodeURIComponent(blobUrl)}`)
if(response.meta.status){
return response.data.url
}
else {
    return blobUrl
}
}